import React from 'react';
import { Icon } from '@noths/polaris-design-system-core-components';

import type { BadgeProps } from './Badge.types';
import * as styles from './Badge.styles';

export const Badge = ({ icon, label, size = 'default', tone = 'default' }: BadgeProps) => (
  <span css={styles.badge} data-size={size} data-testid="badge" data-tone={tone}>
    {icon && (
      <span css={styles.icon}>
        <Icon aria-hidden data-icon={icon} name={icon} size="sm" />
      </span>
    )}
    <span css={styles.label}>{label}</span>
  </span>
);

Badge.displayName = 'Badge';
